import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {Popup, Select, Explanation_text} from '../../../components';
import {Form, Field} from 'react-final-form';


function remove_option(id, data){ let new_data=[]; for(let d of data){if(d.id!=id){new_data.push(d);}} return new_data;}


export function Decisions_merge_popup(props){
  function onSubmit(params){props.mergeWorkspaceDecisions(params.from_id, params.to_id)}

  return(
    <Form
      onSubmit={onSubmit}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
      <Popup always_open accept_button={'Merge'} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} title='merge_custom_decisions_popup_title' handleClose={props.handleClose} content={
        <div style={{width:'95vw', maxWidth:'500px', height:'200px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'20px'}}><Typography color='error' variant='caption'><Explanation_text variant='caption' color='error' text='merge_custom_decisions_popup_warning_text'/></Typography></div>
          <Grid container style={{marginTop:'40px', width:'calc(100% - 40px)', marginLeft:'20px'}}><Grid item xs={6}><Select title='From' name='from' select_data={props.workspace.workspace_decisions}/></Grid><Grid item xs={6}><Field name='from'>{(f)=><Select title='To' name='to' select_data={remove_option(f.input.value, props.workspace.workspace_decisions)}/>}</Field></Grid></Grid>
        </div>
      }/>
      </form>
    )}
    </Form>
   )
}


export function Decisions_delete_popup(props){

  function onSubmit(params){props.deleteWorkspaceDecision(params.id);}

  return(
    <Form
      onSubmit={onSubmit}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
      <Popup always_open accept_button={'Delete'} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} title='delete_custom_decisions_popup_title' handleClose={props.handleClose} content={
        <div style={{width:'95vw', maxWidth:'500px', height:'200px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'20px'}}><Typography color='error' variant='caption'><Explanation_text variant='caption' color='error' text='delete_custom_decisions_popup_warning_text'/></Typography></div>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'30px'}}><Select name='id' select_data={props.workspace.workspace_decisions}/></div>
        </div>
      }/>
      </form>
    )}
    </Form>
   )
}

//export function Custom_fields_merge_popup(props){
//  function onSubmit(params){props.mergeWorkspaceFields(params.from_id, params.to_id)}
//  let company_workspace_fields=[]; if(props.workspace!=undefined && props.workspace.workspace_fields!=undefined){for(let wf of props.workspace.workspace_fields){if(wf.entity_type=='COMPANY'){company_workspace_fields.push(wf);}}}
//  return(
//    <Form
//      onSubmit={onSubmit}
//    >
//      {form_props => (
//        <form onSubmit={form_props.handleSubmit}>
//      <Popup always_open accept_button={'Merge'} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} title='merge_custom_fields_popup_title' handleClose={props.handleClose} content={
//        <div style={{width:'95vw', maxWidth:'500px', height:'200px'}}>
//          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'20px'}}><Explanation_text variant='caption' color='error' text='merge_custom_fields_popup_warning_text'/></div>
//          <Grid container style={{marginTop:'40px', width:'calc(100% - 40px)', marginLeft:'20px'}}><Grid item xs={6}><Select title='From' name='from' select_data={company_workspace_fields}/></Grid><Grid item xs={6}><Field name='from'>{(f)=><Select title='To' name='to' select_data={remove_option(f.input.value, company_workspace_fields)}/>}</Field></Grid></Grid>
//        </div>
//      }/>
//      </form>
//    )}
//    </Form>
//   )
//}




//export function Custom_fields_delete_popup(props){
//
//  function onSubmit(params){props.deleteWorkspaceField(params.id)}
//
//  let company_workspace_fields=[]; if(props.workspace!=undefined && props.workspace.workspace_fields!=undefined){for(let wf of props.workspace.workspace_fields){if(wf.entity_type=='COMPANY'){company_workspace_fields.push(wf);}}}
//
//  return(
//    <Form
//      onSubmit={onSubmit}
//    >
//      {form_props => (
//        <form onSubmit={form_props.handleSubmit}>
//      <Popup always_open accept_button={'Delete'} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} title='delete_custom_fields_popup_title' handleClose={props.handleClose} content={
//        <div style={{width:'95vw', maxWidth:'500px', height:'200px'}}>
//          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'20px'}}><Explanation_text variant='caption' color='error' text='delete_custom_fields_popup_warning_text'/></div>
//          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'30px'}}><Select name='id' select_data={company_workspace_fields}/></div>
//        </div>
//      }/>
//      </form>
//    )}
//    </Form>
//   )
//}
